import AniFadeIn from './AniFadeIn';
import AniFadeOut from './AniFadeOut';
import AniScaleDown from './AniScaleDown';
import AniScaleUp from './AniScaleUp';
import AniSlideDown from './AniSlideDown';
import AniSlideUp from './AniSlideUp';

export {
  AniSlideUp,
  AniSlideDown,
  AniScaleUp,
  AniScaleDown,
  AniFadeIn,
  AniFadeOut,
};
